module.exports = "/images/vendor/flag-icon-css/flags/1x1/ec.svg?5e9624dfa7ecdab7d752a423bc88fa3e";